import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

const optionalText = z.preprocess(
  (value) => {
    if (value == null || value === "") return undefined;
    return value;
  },
  z.string().optional()
);

const requiredDate = (label) =>
  z.preprocess(
    (value) => {
      if (value === "" || value == null) return undefined;
      const parsed = value instanceof Date ? value : new Date(value);
      return parsed;
    },
    z.date({
      required_error: `${label} is required`,
      invalid_type_error: `${label} is required`,
    })
  );

const DriverSchema = z
  .object({
    firstName: requiredText("First name"),
    lastName: requiredText("Last name"),
    maritalStatus: requiredText("Marital status"),
    dateOfBirth: requiredDate("Date of birth"),
    gender: requiredText("Gender"),
    educationLevel: requiredText("Education level"),
    licenseType: requiredText("License type"),
    sr22: z.boolean().default(false),
    licensedDuration: requiredText("Licensed duration"),
    driverLicense: optionalText,
    employmentType: requiredText("Employment type"),
    employmentLine: optionalText,
    autoDriverStatus: requiredText("Auto driver status"),
    distantStudentDiscount: z.boolean().default(false),
    goodStudentDiscount: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (
      (data.employmentType === "Full time" ||
        data.employmentType === "Part Time") &&
      !String(data.employmentLine || "").trim()
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["employmentLine"],
        message: "Employment line is required",
      });
    }
  });

export const Step4Schema = z.object({
  drivers: z
    .array(DriverSchema)
    .min(1, "Please add at least one driver")
    .max(6, "Maximum of 6 drivers"),
});
